export const FETCH_PRIVACY_PAGE = "fetchPrivacyPage";
